<template>
    <div class="player w-100">
        <iframe
            ref="iframeContent"
            :src="this.iframe.src"
            :style="iframe.style"
            width="100%"
            height="100%"
            allowfullscreen="true"
            allowvr="yes"
            allow="vr; xr; accelerometer; magnetometer; gyroscope; webvr; webxr; xr-spatial-tracking;"
            frameborder="0"
        ></iframe>
    </div>
</template>

<script>
export default {
    name: 'Player',
    props: {
        video: String,
        contentId: {
            type: Number,
            required: true,
        },
        progress: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            domain: window.axios.PLAYER_DOMAIN,
            iframe: {
                src: null,
                style: null,
                wrapperStyle: null,
                loaded: false,
            },
            sending: false,
            skipped: false,
        };
    },
    watch: {
        video() {
            this.urlVideo();
        },
    },
    methods: {
        urlVideo() {
            // Método chamado sempre que a url do vídeo muda, em caso de mudar de
            // um vídeo para outro, então é necessário remover o eventListener que
            // foi associado ao iframe do vídeo anterior
            this.removeEventListenerOnChangeVideo();

            this.iframe = {
                ...this.iframe,
                src: `${this.domain}/${this.video}`,
            };

            setTimeout(this.load, 2000);
        },
        updateProgress(res) {
            if (res.origin !== this.domain) return;

            const result = JSON.parse(res.data);
            if (result.eventName === 'jmvplayerout-screencast' && !this.sending) {
                this.sending = true;
                window.axios
                    .post(`/api/app/lesson/content/log/${this.contentId}`, {
                        attributes: {
                            duration: result.duration,
                            currentTime: result.currentTime,
                        },
                    })
                    .then(() => {
                        this.iframe = {};
                        window.location.reload();
                    })
                    .catch(err => console.error(err));
            }
            this.$emit('info', result);
        },
        removeEventListenerOnChangeVideo() {
            const newEvent = (event) => {
                if (event.source === this.$refs.iframeContent.contentWindow) {
                    this.updateProgress(event);
                }
            };

            window.removeEventListener('message', (event) => {
                newEvent(event);
                this.skip(event);
            }, false);
        },
        syncPlayerProgress() {
            // Envia o postMessage para o iframe do vídeo, para que o iframe envie
            // notificação de progresso do vídeo
            this.$refs.iframeContent.contentWindow.postMessage(JSON.stringify({
                public_event: 'jmvplayer-sync',
                screencast: '',
            }), '*');
            // Cria um eventListener para o iframe do vídeo
            const newEvent = (event) => {
                if (event.source === this.$refs.iframeContent.contentWindow) {
                    this.updateProgress(event);
                }
            };
            // Adiciona o eventListener para o iframe do vídeo
            window.addEventListener('message', (event) => {
                newEvent(event);
                this.skip(event);
            }, false);
        },
        getScreencastInfo() {
            return window.axios
                .get('/api/app/lesson/content/screencast-info')
                .then(res => res.data)
                .catch(err => console.error(err));
        },
        async screencastPost() {
            const screencastInfo = await this.getScreencastInfo();

            this.$refs.iframeContent.contentWindow.postMessage(JSON.stringify({
                public_event: 'jmvplayer-screencast',
                screencast: screencastInfo,
            }), '*');
        },
        load() {
            // Carrega o iframe e envia o postMessage para o iframe
            this.iframe.loaded = true;
            setTimeout(this.syncPlayerProgress, 2000);
            setTimeout(this.screencastPost, 4000);
            // Altera o valor de skipped para false, para que o próximo vídeo possa
            // ser pulado para o tempo que já foi assistido
            this.skipped = false;
        },
        currentProgress(currentTime, duration) {
            return Math.round((currentTime / duration) * 100);
        },

        timeToSkip(duration) {
            return (this.progress * duration) / 100;
        },
        skip(res) {
            if (res.origin !== this.domain) return;

            const result = JSON.parse(res.data);

            if (!this.skipped &&
                this.progress >= this.currentProgress(result.currentTime, result.duration)) {
                this.$refs.iframeContent.contentWindow.postMessage(
                    JSON.stringify({ public_event: 'jmvplayer-jump', jump: this.timeToSkip(result.duration) }),
                    '*',
                );

                this.skipped = true;
            }
        },
        skipToLastTime() {
            window.addEventListener('message', this.skip, false);
        },
    },
    mounted() {
        this.urlVideo();
    },
};
</script>

<style>
.player iframe {
    border: none;
}
@media print {
    .player {
        display: none;  /* hide whole page */
    }
}
</style>
